export default __webpack_public_path__ + "static/miceBanner_1796-16d7489f5aaf7c31bc30c3d4a0206833.jpg";